export default function Footer() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-white/80">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <span className="text-xl font-heading font-bold text-white mb-4 block">
                69视频
              </span>
              <p className="text-sm text-white/50 leading-relaxed">
                69视频汇聚丝瓜视频、蓝莓视频、糖心视频、黑桃视频等特色视频网站，
                提供丰富的在线视频资源免费观看，高清流畅不缓冲播放，
                持续为你发现独特的视频内容。
              </p>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-white mb-4">快速导航</h3>
              <nav className="flex flex-col gap-2">
                {[
                  { label: '热门话题', href: '#topics' },
                  { label: '视频热度榜', href: '#ranking' },
                  { label: '专题合集', href: '#index' },
                  { label: '最新快讯', href: '#updates' },
                  { label: '常见问答', href: '#faq' },
                ].map((item) => (
                  <a
                    key={item.href}
                    href={item.href}
                    onClick={(e) => handleScroll(e, item.href)}
                    className="text-sm text-white/50 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </a>
                ))}
              </nav>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-white mb-4">特色站点</h3>
              <div className="flex flex-wrap gap-2">
                {['丝瓜视频', '蓝莓视频', '糖心视频', '黑桃视频', '妖精视频', '桃花视频'].map(
                  (name) => (
                    <span
                      key={name}
                      className="px-2.5 py-1 rounded-md text-xs bg-white/8 text-white/50 whitespace-nowrap"
                    >
                      {name}
                    </span>
                  )
                )}
              </div>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-white mb-4">合作伙伴</h3>
              <div className="flex flex-wrap gap-2">
                <span className="px-2.5 py-1 rounded-md text-xs bg-white/8 text-white/40 whitespace-nowrap">
                  更多站点接入中
                </span>
              </div>
              <div className="mt-6">
                <h3 className="text-sm font-semibold text-white mb-2">联系我们</h3>
                <a
                  href="#contact"
                  onClick={(e) => handleScroll(e, '#contact')}
                  className="text-sm text-white/50 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  投稿与合作咨询
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-white/35">
              &copy; {new Date().getFullYear()} 69视频 - 特色视频网站大全. 仅供学习交流，如有侵权请联系删除.
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-white/30 whitespace-nowrap">安全访问</span>
              <span className="text-xs text-white/30 whitespace-nowrap">隐私保护</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}